import axios from "axios";
import { useAlert } from "react-alert";
import { useParams } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import { GlobalContext } from "../../context/GlobalState.jsx";
import { LearningContentLayout } from "../../shared/ui/Learning/LearningContentLayout.jsx";
import { TopicList } from "../../shared/domain/learning/components/TopicList.jsx";

import { decodeHTMLEntities } from "../../shared/utils/url.js";

import "./styles/LearningResources.css";

export default function Topics(props) {
  document.title = "2xcell.in";
  const history = useHistory();
  const alert = useAlert();
  const params = useParams();
  const { userDetails, setUserDetails } = useContext(GlobalContext);

  const [topicList, setTopicList] = useState([]);
  const chapterId = params.chapterId;
  const subjectName = decodeHTMLEntities(params.subject);
  const chapterName = decodeHTMLEntities(params.chapter);

  const [fetched, setFetched] = useState(false);

  const openTopic = (topic) => {
    history.push(
      `${props.match.url}/topic/${decodeHTMLEntities(topic.name)}/${topic._id}`,
      { topicId: props.id },
    );
  };

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    const apiForTopics = `${process.env.REACT_APP_ORIGIN}/api/v1/chapters/${chapterId}`;
    axios
      .get(apiForTopics, {
        headers: {
          token: authToken,
        },
      })
      .then((resp) => {
        let topics = resp.data.data.chapter.totalTopics
          ? resp.data.data.chapter.topics
              .filter(
                (item) => item.lang === window.localStorage.getItem("language"),
              )
              .sort((a, b) => a.priority - b.priority)
          : [];
        setTopicList(topics);
        setFetched(true);
      })
      .catch((err) => {
        alert.error("Topics not fetched");
        console.error(err);
      });
  }, []);

  useEffect(() => {
    setUserDetails({ ...userDetails, selectedTab: "2Xcell Resources" });
    setUserDetails({
      ...userDetails,
      selectedPath: {
        subject: subjectName,
        chapter: chapterName,
        topic: "",
      },
    });
  }, []);

  return (
    <LearningContentLayout
      grade={`${userDetails.grade} - ${userDetails.section}`}
      resourcePage={`${subjectName} > ${chapterName}`}
    >
      <TopicList topics={topicList} loading={fetched} onClick={openTopic} />
    </LearningContentLayout>
  );
}
